import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PreciosService } from '@precios/precios.service';
import { TipoNivelAprobacion } from '@shared/enums/tipoNivelAprobacion';
import { NivelAprobacion } from '@shared/models/precios/NivelAprobacion';
import { MessageService } from '@shell/message.service';
import { FacturacionService } from '../../facturacion.service';
import { Motivo } from '@shared/enums/Motivo';

@Component({
  selector: 'app-modal-nivel-refacturacion',
  templateUrl: './modal-nivel-refacturacion.component.html',
  styleUrls: ['./modal-nivel-refacturacion.component.css']
})
export class ModalNivelRefacturacionComponent implements OnInit {

  @Input() tipoNivel: TipoNivelAprobacion;
  @Input() nivelAprobacionSeleccionado: NivelAprobacion;
  motivosSeleccionados: number[] = [];

  enumTipoNivel = TipoNivelAprobacion;
  form: UntypedFormGroup;

  editando: boolean;
  guardandoNivel: boolean = false;

  Motivo = Motivo;

  constructor(
    private preciosService: PreciosService,
    private facturacionService: FacturacionService,
    private messageService: MessageService,
    private activeModal: NgbActiveModal,
    private modalAceptar: NgbModal) {
  }

  // hooks

  ngOnInit() {
    this.crearFormulario();

    if (this.nivelAprobacionSeleccionado == null) {
      this.editando = false;
      this.activoFormControl.setValue(true);
    } else {
      this.editando = true;
      this.cargarInfoNivelAprobacion();
    }
  }

  // forms

  crearFormulario() {
    this.form = new FormGroup({
      codigoFormControl: new FormControl('', Validators.required),
      nombreFormControl: new FormControl('', Validators.required),
      montoMaximoFormControl: new FormControl('', Validators.required),
      activoFormControl: new FormControl(),
      plazoCheckFormControl: new FormControl(),
      impuestosCheckFormControl: new FormControl(),
      otrosCheckFormControl: new FormControl(),
      preciosCheckFormControl: new FormControl(),
      despachoCheckFormControl: new FormControl(),
      litrosCheckFormControl: new FormControl(),
      serviciosCheckFormControl: new FormControl()
    });
  }

  seleccionarDocumentos(motivo: number, event) {
    if (event.target.checked) {
      this.motivosSeleccionados.push(motivo);
    } else {
      const indice = this.motivosSeleccionados.indexOf(motivo);
      if (indice != -1) {
        this.motivosSeleccionados.splice(indice, 1);
      }
    }
    console.log("motivos seleccionadas " + JSON.stringify(this.motivosSeleccionados))
  }

  cargarInfoNivelAprobacion() {
    this.nivelAprobacionSeleccionado.tipoNivel = 2;
    this.codigoFormControl.setValue(this.nivelAprobacionSeleccionado.codigo);
    this.nombreFormControl.setValue(this.nivelAprobacionSeleccionado.nombre);
    this.montoMaximoFormControl.setValue(this.nivelAprobacionSeleccionado.montoMaximoAprobacion);
    this.motivosSeleccionados = this.nivelAprobacionSeleccionado.motivos;
    for (const m of this.nivelAprobacionSeleccionado.motivos) {
      switch (m) {
        case Motivo.Plazo: this.plazoCheckFormControl.setValue(true);
          break;
        case Motivo.Impuestos: this.impuestosCheckFormControl.setValue(true);
          break;
        case Motivo.Otros: this.otrosCheckFormControl.setValue(true);
          break;
        case Motivo.Precio: this.preciosCheckFormControl.setValue(true);
          break;
        case Motivo.Despacho: this.despachoCheckFormControl.setValue(true);
          break;
        case Motivo.Litros: this.litrosCheckFormControl.setValue(true);
          break;
        case Motivo.Servicios: this.serviciosCheckFormControl.setValue(true);
          break;
      }
    }
  }

  // conexiones al service

  onSubmit() {
    this.guardandoNivel = true;

    if (!this.editando) {
      this.nivelAprobacionSeleccionado = new NivelAprobacion();
    }

    this.nivelAprobacionSeleccionado.tipoNivel = 2;
    this.nivelAprobacionSeleccionado.codigo = this.codigoFormControl.value;
    this.nivelAprobacionSeleccionado.nombre = this.nombreFormControl.value;
    this.nivelAprobacionSeleccionado.montoMaximoAprobacion = this.montoMaximoFormControl.value;
    this.nivelAprobacionSeleccionado.motivos = this.motivosSeleccionados;
    this.nivelAprobacionSeleccionado.activo = true;

    if (!this.editando) {
      this.preciosService.crearNivelAprobacion(this.nivelAprobacionSeleccionado)
        .subscribe(nivelAprobacion => {
          this.guardandoNivel = false;
          this.activeModal.close(nivelAprobacion);
        },
          () => {
            this.messageService.showErrorMessage("Error al guardar el nivel");
            this.guardandoNivel = false;
          });
    } else {
      this.preciosService.editarNivelAprobacion(this.nivelAprobacionSeleccionado)
        .subscribe(nivelAprobacion => {
          this.guardandoNivel = false;
          this.activeModal.close(nivelAprobacion);
        },
          () => {
            this.messageService.showErrorMessage("Error al editar el nivel");
            this.guardandoNivel = false;
          });
      this.guardandoNivel = false;
    }
  }

  // modals

  onCancelar() {
    this.activeModal.dismiss();
  }

  // validaciones

  onlyNumberKey(event) {
    return (event.charCode == 8 || event.charCode == 0 || event.charCode == 46) ? null : event.charCode >= 48 && event.charCode <= 57;
  }

  noPuedeGuardarNivel() {
    return (!(this.form.valid && this.motivosSeleccionados.length > 0) || this.guardandoNivel);
  }

  // getters

  get codigoFormControl() {
    return this.form.controls.codigoFormControl;
  }

  get nombreFormControl() {
    return this.form.controls.nombreFormControl;
  }

  get montoMaximoFormControl() {
    return this.form.controls.montoMaximoFormControl;
  }

  get puedeDesactivarFormControl() {
    return this.form.controls.puedeDesactivarFormControl;
  }

  get activoFormControl() {
    return this.form.controls.activoFormControl;
  }

  get maximaVariacionFormControl() {
    return this.form.controls.maximaVariacionFormControl;
  }

  get maximaBonificacionFormControl() {
    return this.form.controls.maximaBonificacionFormControl;
  }

  get maximoRecargoFormControl() {
    return this.form.controls.maximoRecargoFormControl;
  }

  get documentosFormControl() {
    return this.form.controls.documentosFormControl;
  }
  get plazoCheckFormControl() {
    return this.form.controls.plazoCheckFormControl;
  }
  get impuestosCheckFormControl() {
    return this.form.controls.impuestosCheckFormControl;
  }
  get otrosCheckFormControl() {
    return this.form.controls.otrosCheckFormControl
  }
  get preciosCheckFormControl() {
    return this.form.controls.preciosCheckFormControl
  }
  get despachoCheckFormControl() {
    return this.form.controls.despachoCheckFormControl
  }
  get litrosCheckFormControl() {
    return this.form.controls.litrosCheckFormControl
  }
  get serviciosCheckFormControl() {
    return this.form.controls.serviciosCheckFormControl
  }
}
